import { render, staticRenderFns } from "./CustomCheckboxButton.vue?vue&type=template&id=0af3f91e"
import script from "./CustomCheckboxButton.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports